export default __webpack_public_path__ + "static/media/TRANSPORTE.411a53c4.jpg";